import { defaultSelect } from 'src/constants'
import { EMediaConnectionType } from 'src/types'

const formatLabel = (value: string) => {
  return value.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
}

const useMediaConnectionTypeSelectionOption = () => {
  const values = Object.values(EMediaConnectionType).map((value) => ({
    value: value,
    label: formatLabel(value),
  }))

  return {
    selectName: 'media-connection-type-filter-title.v',
    queryParamName: 'connection_type',
    items: [defaultSelect, ...values],
  }
}

export { useMediaConnectionTypeSelectionOption }
